export function installAnalyticsScripts() {
  const gtmId = import.meta.env.VITE_GTM_CONTAINER_ID || import.meta.env.GTM_CONTAINER_ID;
  const ga4Id = import.meta.env.VITE_GA4_MEASUREMENT_ID || import.meta.env.GA4_MEASUREMENT_ID;
  const umamiScriptUrl = import.meta.env.VITE_UMAMI_SCRIPT_URL || import.meta.env.PUBLIC_UMAMI_SCRIPT_URL;
  const umamiWebsiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID || import.meta.env.PUBLIC_UMAMI_WEBSITE_ID;

  if (gtmId && !document.querySelector(`[data-ocg-script="gtm"]`)) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.dataset.ocgScript = "gtm";
    document.head.appendChild(script);
  }

  if (!gtmId && ga4Id && !document.querySelector(`[data-ocg-script="ga4"]`)) {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag(...args: unknown[]) {
        window.dataLayer?.push(args);
      };

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    script.dataset.ocgScript = "ga4";
    document.head.appendChild(script);

    window.gtag("js", new Date());
    window.gtag("config", ga4Id);
  }

  if (umamiScriptUrl && umamiWebsiteId && !document.querySelector(`[data-ocg-script="umami"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = umamiScriptUrl;
    script.dataset.websiteId = umamiWebsiteId;
    script.dataset.ocgScript = "umami";
    document.head.appendChild(script);
  }
}
